import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import UserList from "../../components/User/UserListLayer";


const UserListPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Users" />

        {/* UsersListLayer */}
        <UserList />

      </MasterLayout>

    </>
  );
};

export default UserListPage; 
